/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AuthAuthLayoutRouteImport } from './routes/auth/_authLayout'
import { Route as AppReportingRouteImport } from './routes/_app/reporting'
import { Route as AppMediaPlansRouteImport } from './routes/_app/media-plans'
import { Route as AppChangelogRouteImport } from './routes/_app/changelog'
import { Route as AppAudienceLibraryRouteImport } from './routes/_app/audience-library'
import { Route as AppTraffickingIndexRouteImport } from './routes/_app/trafficking/index'
import { Route as AppAlgorithmToolsIndexRouteImport } from './routes/_app/algorithm-tools/index'
import { Route as AuthAuthLayoutLogoutRouteImport } from './routes/auth/_authLayout/logout'
import { Route as AuthAuthLayoutLoginRouteImport } from './routes/auth/_authLayout/login'
import { Route as AuthAuthLayoutLoggedOutRouteImport } from './routes/auth/_authLayout/logged-out'
import { Route as AppTraffickingInsertionOrderRouteImport } from './routes/_app/trafficking/insertion-order'
import { Route as AppTraffickingCampaignRouteImport } from './routes/_app/trafficking/campaign'
import { Route as AppTraffickingAdvertiserRouteImport } from './routes/_app/trafficking/advertiser'
import { Route as AppTraffickingAdUnitRouteImport } from './routes/_app/trafficking/ad-unit'
import { Route as AppMediaPlansIdRouteImport } from './routes/_app/media-plans_.$id'
import { Route as AppAlgorithmToolsStarvationBidderRouteImport } from './routes/_app/algorithm-tools/starvation-bidder'
import { Route as AppAlgorithmToolsOfflineSalesOptimizerRouteImport } from './routes/_app/algorithm-tools/offline-sales-optimizer'

const AuthRouteImport = createFileRoute('/auth')()

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthLayoutRoute = AuthAuthLayoutRouteImport.update({
  id: '/_authLayout',
  getParentRoute: () => AuthRoute,
} as any)
const AppReportingRoute = AppReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => AppRoute,
} as any)
const AppMediaPlansRoute = AppMediaPlansRouteImport.update({
  id: '/media-plans',
  path: '/media-plans',
  getParentRoute: () => AppRoute,
} as any)
const AppChangelogRoute = AppChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AppRoute,
} as any)
const AppAudienceLibraryRoute = AppAudienceLibraryRouteImport.update({
  id: '/audience-library',
  path: '/audience-library',
  getParentRoute: () => AppRoute,
} as any)
const AppTraffickingIndexRoute = AppTraffickingIndexRouteImport.update({
  id: '/trafficking/',
  path: '/trafficking/',
  getParentRoute: () => AppRoute,
} as any)
const AppAlgorithmToolsIndexRoute = AppAlgorithmToolsIndexRouteImport.update({
  id: '/algorithm-tools/',
  path: '/algorithm-tools/',
  getParentRoute: () => AppRoute,
} as any)
const AuthAuthLayoutLogoutRoute = AuthAuthLayoutLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const AuthAuthLayoutLoginRoute = AuthAuthLayoutLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const AuthAuthLayoutLoggedOutRoute = AuthAuthLayoutLoggedOutRouteImport.update({
  id: '/logged-out',
  path: '/logged-out',
  getParentRoute: () => AuthAuthLayoutRoute,
} as any)
const AppTraffickingInsertionOrderRoute =
  AppTraffickingInsertionOrderRouteImport.update({
    id: '/trafficking/insertion-order',
    path: '/trafficking/insertion-order',
    getParentRoute: () => AppRoute,
  } as any)
const AppTraffickingCampaignRoute = AppTraffickingCampaignRouteImport.update({
  id: '/trafficking/campaign',
  path: '/trafficking/campaign',
  getParentRoute: () => AppRoute,
} as any)
const AppTraffickingAdvertiserRoute =
  AppTraffickingAdvertiserRouteImport.update({
    id: '/trafficking/advertiser',
    path: '/trafficking/advertiser',
    getParentRoute: () => AppRoute,
  } as any)
const AppTraffickingAdUnitRoute = AppTraffickingAdUnitRouteImport.update({
  id: '/trafficking/ad-unit',
  path: '/trafficking/ad-unit',
  getParentRoute: () => AppRoute,
} as any)
const AppMediaPlansIdRoute = AppMediaPlansIdRouteImport.update({
  id: '/media-plans_/$id',
  path: '/media-plans/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAlgorithmToolsStarvationBidderRoute =
  AppAlgorithmToolsStarvationBidderRouteImport.update({
    id: '/algorithm-tools/starvation-bidder',
    path: '/algorithm-tools/starvation-bidder',
    getParentRoute: () => AppRoute,
  } as any)
const AppAlgorithmToolsOfflineSalesOptimizerRoute =
  AppAlgorithmToolsOfflineSalesOptimizerRouteImport.update({
    id: '/algorithm-tools/offline-sales-optimizer',
    path: '/algorithm-tools/offline-sales-optimizer',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/audience-library': typeof AppAudienceLibraryRoute
  '/changelog': typeof AppChangelogRoute
  '/media-plans': typeof AppMediaPlansRoute
  '/reporting': typeof AppReportingRoute
  '/auth': typeof AuthAuthLayoutRouteWithChildren
  '/auth/': typeof AuthIndexRoute
  '/algorithm-tools/offline-sales-optimizer': typeof AppAlgorithmToolsOfflineSalesOptimizerRoute
  '/algorithm-tools/starvation-bidder': typeof AppAlgorithmToolsStarvationBidderRoute
  '/media-plans/$id': typeof AppMediaPlansIdRoute
  '/trafficking/ad-unit': typeof AppTraffickingAdUnitRoute
  '/trafficking/advertiser': typeof AppTraffickingAdvertiserRoute
  '/trafficking/campaign': typeof AppTraffickingCampaignRoute
  '/trafficking/insertion-order': typeof AppTraffickingInsertionOrderRoute
  '/auth/logged-out': typeof AuthAuthLayoutLoggedOutRoute
  '/auth/login': typeof AuthAuthLayoutLoginRoute
  '/auth/logout': typeof AuthAuthLayoutLogoutRoute
  '/algorithm-tools': typeof AppAlgorithmToolsIndexRoute
  '/trafficking': typeof AppTraffickingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/audience-library': typeof AppAudienceLibraryRoute
  '/changelog': typeof AppChangelogRoute
  '/media-plans': typeof AppMediaPlansRoute
  '/reporting': typeof AppReportingRoute
  '/auth': typeof AuthIndexRoute
  '/algorithm-tools/offline-sales-optimizer': typeof AppAlgorithmToolsOfflineSalesOptimizerRoute
  '/algorithm-tools/starvation-bidder': typeof AppAlgorithmToolsStarvationBidderRoute
  '/media-plans/$id': typeof AppMediaPlansIdRoute
  '/trafficking/ad-unit': typeof AppTraffickingAdUnitRoute
  '/trafficking/advertiser': typeof AppTraffickingAdvertiserRoute
  '/trafficking/campaign': typeof AppTraffickingCampaignRoute
  '/trafficking/insertion-order': typeof AppTraffickingInsertionOrderRoute
  '/auth/logged-out': typeof AuthAuthLayoutLoggedOutRoute
  '/auth/login': typeof AuthAuthLayoutLoginRoute
  '/auth/logout': typeof AuthAuthLayoutLogoutRoute
  '/algorithm-tools': typeof AppAlgorithmToolsIndexRoute
  '/trafficking': typeof AppTraffickingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/audience-library': typeof AppAudienceLibraryRoute
  '/_app/changelog': typeof AppChangelogRoute
  '/_app/media-plans': typeof AppMediaPlansRoute
  '/_app/reporting': typeof AppReportingRoute
  '/auth': typeof AuthRouteWithChildren
  '/auth/_authLayout': typeof AuthAuthLayoutRouteWithChildren
  '/auth/': typeof AuthIndexRoute
  '/_app/algorithm-tools/offline-sales-optimizer': typeof AppAlgorithmToolsOfflineSalesOptimizerRoute
  '/_app/algorithm-tools/starvation-bidder': typeof AppAlgorithmToolsStarvationBidderRoute
  '/_app/media-plans_/$id': typeof AppMediaPlansIdRoute
  '/_app/trafficking/ad-unit': typeof AppTraffickingAdUnitRoute
  '/_app/trafficking/advertiser': typeof AppTraffickingAdvertiserRoute
  '/_app/trafficking/campaign': typeof AppTraffickingCampaignRoute
  '/_app/trafficking/insertion-order': typeof AppTraffickingInsertionOrderRoute
  '/auth/_authLayout/logged-out': typeof AuthAuthLayoutLoggedOutRoute
  '/auth/_authLayout/login': typeof AuthAuthLayoutLoginRoute
  '/auth/_authLayout/logout': typeof AuthAuthLayoutLogoutRoute
  '/_app/algorithm-tools/': typeof AppAlgorithmToolsIndexRoute
  '/_app/trafficking/': typeof AppTraffickingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/audience-library'
    | '/changelog'
    | '/media-plans'
    | '/reporting'
    | '/auth'
    | '/auth/'
    | '/algorithm-tools/offline-sales-optimizer'
    | '/algorithm-tools/starvation-bidder'
    | '/media-plans/$id'
    | '/trafficking/ad-unit'
    | '/trafficking/advertiser'
    | '/trafficking/campaign'
    | '/trafficking/insertion-order'
    | '/auth/logged-out'
    | '/auth/login'
    | '/auth/logout'
    | '/algorithm-tools'
    | '/trafficking'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/audience-library'
    | '/changelog'
    | '/media-plans'
    | '/reporting'
    | '/auth'
    | '/algorithm-tools/offline-sales-optimizer'
    | '/algorithm-tools/starvation-bidder'
    | '/media-plans/$id'
    | '/trafficking/ad-unit'
    | '/trafficking/advertiser'
    | '/trafficking/campaign'
    | '/trafficking/insertion-order'
    | '/auth/logged-out'
    | '/auth/login'
    | '/auth/logout'
    | '/algorithm-tools'
    | '/trafficking'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/_app'
    | '/_app/audience-library'
    | '/_app/changelog'
    | '/_app/media-plans'
    | '/_app/reporting'
    | '/auth'
    | '/auth/_authLayout'
    | '/auth/'
    | '/_app/algorithm-tools/offline-sales-optimizer'
    | '/_app/algorithm-tools/starvation-bidder'
    | '/_app/media-plans_/$id'
    | '/_app/trafficking/ad-unit'
    | '/_app/trafficking/advertiser'
    | '/_app/trafficking/campaign'
    | '/_app/trafficking/insertion-order'
    | '/auth/_authLayout/logged-out'
    | '/auth/_authLayout/login'
    | '/auth/_authLayout/logout'
    | '/_app/algorithm-tools/'
    | '/_app/trafficking/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/'
      fullPath: '/auth/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/_authLayout': {
      id: '/auth/_authLayout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthAuthLayoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/reporting': {
      id: '/_app/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof AppReportingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/media-plans': {
      id: '/_app/media-plans'
      path: '/media-plans'
      fullPath: '/media-plans'
      preLoaderRoute: typeof AppMediaPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/changelog': {
      id: '/_app/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AppChangelogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audience-library': {
      id: '/_app/audience-library'
      path: '/audience-library'
      fullPath: '/audience-library'
      preLoaderRoute: typeof AppAudienceLibraryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trafficking/': {
      id: '/_app/trafficking/'
      path: '/trafficking'
      fullPath: '/trafficking'
      preLoaderRoute: typeof AppTraffickingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/algorithm-tools/': {
      id: '/_app/algorithm-tools/'
      path: '/algorithm-tools'
      fullPath: '/algorithm-tools'
      preLoaderRoute: typeof AppAlgorithmToolsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/_authLayout/logout': {
      id: '/auth/_authLayout/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthAuthLayoutLogoutRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_authLayout/login': {
      id: '/auth/_authLayout/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthAuthLayoutLoginRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/auth/_authLayout/logged-out': {
      id: '/auth/_authLayout/logged-out'
      path: '/logged-out'
      fullPath: '/auth/logged-out'
      preLoaderRoute: typeof AuthAuthLayoutLoggedOutRouteImport
      parentRoute: typeof AuthAuthLayoutRoute
    }
    '/_app/trafficking/insertion-order': {
      id: '/_app/trafficking/insertion-order'
      path: '/trafficking/insertion-order'
      fullPath: '/trafficking/insertion-order'
      preLoaderRoute: typeof AppTraffickingInsertionOrderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trafficking/campaign': {
      id: '/_app/trafficking/campaign'
      path: '/trafficking/campaign'
      fullPath: '/trafficking/campaign'
      preLoaderRoute: typeof AppTraffickingCampaignRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trafficking/advertiser': {
      id: '/_app/trafficking/advertiser'
      path: '/trafficking/advertiser'
      fullPath: '/trafficking/advertiser'
      preLoaderRoute: typeof AppTraffickingAdvertiserRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trafficking/ad-unit': {
      id: '/_app/trafficking/ad-unit'
      path: '/trafficking/ad-unit'
      fullPath: '/trafficking/ad-unit'
      preLoaderRoute: typeof AppTraffickingAdUnitRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/media-plans_/$id': {
      id: '/_app/media-plans_/$id'
      path: '/media-plans/$id'
      fullPath: '/media-plans/$id'
      preLoaderRoute: typeof AppMediaPlansIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/algorithm-tools/starvation-bidder': {
      id: '/_app/algorithm-tools/starvation-bidder'
      path: '/algorithm-tools/starvation-bidder'
      fullPath: '/algorithm-tools/starvation-bidder'
      preLoaderRoute: typeof AppAlgorithmToolsStarvationBidderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/algorithm-tools/offline-sales-optimizer': {
      id: '/_app/algorithm-tools/offline-sales-optimizer'
      path: '/algorithm-tools/offline-sales-optimizer'
      fullPath: '/algorithm-tools/offline-sales-optimizer'
      preLoaderRoute: typeof AppAlgorithmToolsOfflineSalesOptimizerRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAudienceLibraryRoute: typeof AppAudienceLibraryRoute
  AppChangelogRoute: typeof AppChangelogRoute
  AppMediaPlansRoute: typeof AppMediaPlansRoute
  AppReportingRoute: typeof AppReportingRoute
  AppAlgorithmToolsOfflineSalesOptimizerRoute: typeof AppAlgorithmToolsOfflineSalesOptimizerRoute
  AppAlgorithmToolsStarvationBidderRoute: typeof AppAlgorithmToolsStarvationBidderRoute
  AppMediaPlansIdRoute: typeof AppMediaPlansIdRoute
  AppTraffickingAdUnitRoute: typeof AppTraffickingAdUnitRoute
  AppTraffickingAdvertiserRoute: typeof AppTraffickingAdvertiserRoute
  AppTraffickingCampaignRoute: typeof AppTraffickingCampaignRoute
  AppTraffickingInsertionOrderRoute: typeof AppTraffickingInsertionOrderRoute
  AppAlgorithmToolsIndexRoute: typeof AppAlgorithmToolsIndexRoute
  AppTraffickingIndexRoute: typeof AppTraffickingIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAudienceLibraryRoute: AppAudienceLibraryRoute,
  AppChangelogRoute: AppChangelogRoute,
  AppMediaPlansRoute: AppMediaPlansRoute,
  AppReportingRoute: AppReportingRoute,
  AppAlgorithmToolsOfflineSalesOptimizerRoute:
    AppAlgorithmToolsOfflineSalesOptimizerRoute,
  AppAlgorithmToolsStarvationBidderRoute:
    AppAlgorithmToolsStarvationBidderRoute,
  AppMediaPlansIdRoute: AppMediaPlansIdRoute,
  AppTraffickingAdUnitRoute: AppTraffickingAdUnitRoute,
  AppTraffickingAdvertiserRoute: AppTraffickingAdvertiserRoute,
  AppTraffickingCampaignRoute: AppTraffickingCampaignRoute,
  AppTraffickingInsertionOrderRoute: AppTraffickingInsertionOrderRoute,
  AppAlgorithmToolsIndexRoute: AppAlgorithmToolsIndexRoute,
  AppTraffickingIndexRoute: AppTraffickingIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthAuthLayoutRouteChildren {
  AuthAuthLayoutLoggedOutRoute: typeof AuthAuthLayoutLoggedOutRoute
  AuthAuthLayoutLoginRoute: typeof AuthAuthLayoutLoginRoute
  AuthAuthLayoutLogoutRoute: typeof AuthAuthLayoutLogoutRoute
}

const AuthAuthLayoutRouteChildren: AuthAuthLayoutRouteChildren = {
  AuthAuthLayoutLoggedOutRoute: AuthAuthLayoutLoggedOutRoute,
  AuthAuthLayoutLoginRoute: AuthAuthLayoutLoginRoute,
  AuthAuthLayoutLogoutRoute: AuthAuthLayoutLogoutRoute,
}

const AuthAuthLayoutRouteWithChildren = AuthAuthLayoutRoute._addFileChildren(
  AuthAuthLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthAuthLayoutRoute: typeof AuthAuthLayoutRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAuthLayoutRoute: AuthAuthLayoutRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
